// extracted by mini-css-extract-plugin
export default {"table-header":"fU8qPh2b","tableHeader":"fU8qPh2b","table-body":"qiaX7xtu","tableBody":"qiaX7xtu"};